import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import filterIcon from "../images/filterIcon.png";
import searchIcon from "../images/scarchIcon.svg";
import { MdOutlineWifi, MdOutlineWifiOff } from "react-icons/md";
import { LuArrowDownUp } from "react-icons/lu";
import { FiRefreshCcw } from "react-icons/fi";
import UserMenu from "./UserMenu";
import axios from "axios";
import toast from "react-hot-toast";
import { BsAlarm } from "react-icons/bs";
import { getToken } from 'firebase/messaging';
import { ROLES } from "../constants/roles";

import {
  deleteItemsFromIndexedDB,
  fetchDataFromIndexedDB,
} from "../Hooks/IndexedDBUtils";
import { runSyncQueue } from "../utils/offlineSync";
import { syncableContactDB } from "./DatabaseComponent";
import { syncableWolkingListDB } from "./WalkingList";
import { syncableProfile } from "../Pages/ProfileSetting";
import { syncableTracking } from "./CanvassMap";
import { surveyForm } from "../Pages/HubsportForm";
import { syncableMeetingDB, MEETING_STORE, syncMeetingCallApi } from "../utils/offlineMeeting";
import SidebarUnlockModal from "./SidebarUnlockModal";
import { MdOutlineLocationOff } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { refreshAppData, storeLocalData, storeObjectData } from "../utils";
import { LocationContext } from "./LocationContext";
import { useGhostMode } from "../context/GhostModeContext";
import GhostUserSelector from "./GhostUserSelector";
import TenantSwitcherMenu from "./TenantSwitcherMenu";
import GhostModeWarningModal from "./GhostModeWarningModal";
import ConfirmModal from "./ConfirmModal";
import EditInputField from "./EditInputField";
import { messagingReady } from "../config/firebase";
import { useOnlineStatus } from "../Hooks/useOfflineHousehold";
import { registerPushServiceWorker } from "../utils/pushServiceWorker";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const Usersbar = ({
  isMapPage,
  hideSidebar,
  hideSidebarChecked,
  setHideSidebarChecked,
}) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { REACT_APP_BASE_URL } = process.env;
  // Reading navigator.onLine directly only reflects reality at whatever
  // moment this component happens to re-render for some unrelated reason -
  // there's no listener tied to it, so the WiFi icon only "updates" when
  // something else forces a re-render, which reads as "need to refresh the
  // page" to see the correct state. This hook re-renders on the actual
  // 'online'/'offline' browser events.
  const online = useOnlineStatus();
  const token = localStorage.getItem("token");
  const subtitleRef = useRef(null);
  const email = localStorage.getItem("urserMail");
  const { locationPermission, setLocationPermission, location, setLocation } =
    useContext(LocationContext);
  const [isTracking, setIsTracking] = useState(false)
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const {
    isGhostMode,
    userList,
    isLoadingUsers,
    showWarningModal,
    pendingGhostUser,
    ghostTenantChoices,
    fetchUserList,
    initiateGhostMode,
    confirmGhostMode,
    cancelGhostMode,
    selectGhostTenant,
    cancelGhostTenantSelection,
    refreshUserList,
  } = useGhostMode();

  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === ROLES.SUPER_ADMIN;

  function openModal() {
    setIsOpen(true);
  }
  const showLocationToggle = useLocation()?.pathname === "/canvass-map";
  const [employeeNotes, setEmployeeNotes] = useState("");
  const checkLocationPermission = async () => {
    try {
      const permission = await navigator.permissions.query({
        name: "geolocation",
      });
      if (permission.state === "granted") {
        getCurrentLocation();
      } else if (permission.state === "prompt") {
        getCurrentLocation();
      } else if (permission.state === "denied") {
        alert(
          "Location access is blocked. Please enable location permissions in your browser settings."
        );
        setLocation({});
        storeObjectData("currentLocation", {});
        setLocationPermission(false);
      }
    } catch (error) {
      console.error("Permission check failed:", error);
    }
  };

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const newLocation = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        setLocation(newLocation);
        storeObjectData("currentLocation", newLocation);
        setLocationPermission(true);
      },
      (error) => {
        console.error("Geolocation error:", error.message);
        setLocationPermission(false);
        storeObjectData("currentLocation", {});
      }
    );
  };

  const handleLocationClick = () => {
    const newState = !locationPermission;
    setLocationPermission(newState);

    if (newState) {
      checkLocationPermission();
    } else {
      setLocation({});
      storeObjectData("currentLocation", {});
    }
  };

  useEffect(() => {
    storeLocalData("isAllowLocation", locationPermission);
    storeObjectData("currentLocation", location);
  }, [locationPermission]);

  function closeModal() {
    setIsOpen(false);
  }

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      localStorage.setItem("lock", isChecked ? "true" : "false");
      setHideSidebarChecked(isChecked);
      hideSidebar(isChecked);
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, null, window.location.href);
      };
    } else {
      openModal();
    }
  };

  const userMail = localStorage.getItem("urserMail");

  const [owner, setOwner] = useState("");
  const ownerID = localStorage.getItem("ownerId");

  const fetchOwnerList = async () => {
    try {
      const response = await axios.get(`${REACT_APP_BASE_URL}/ownerlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const newData = response.data.results;
      const ownerMail = newData.filter((e) => e.email.toLowerCase() === userMail.toLowerCase());
      setOwner(ownerMail);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const getTimeTrackingStatus = async (id) => {
    const canvasserId = id || localStorage.getItem("ownerId");
    if (!canvasserId) return;
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/time_tracking_get`,
        { canvasser: canvasserId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response?.data) {
        setIsTracking(!!response.data.time_tracking);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    fetchOwnerList();
    window.addEventListener("online", fetchOwnerList);
    return () => window.removeEventListener("online", fetchOwnerList);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isAdmin && navigator.onLine) {
      fetchUserList();
    }
  }, [isAdmin, fetchUserList]);

  useEffect(() => {
    const OwnerId = owner[0]?.id;
    if (OwnerId) {
      localStorage.setItem("ownerId", OwnerId);
      getTimeTrackingStatus(OwnerId);
    }
  }, [owner]);

  const [isSyncing, setIsSyncing] = useState(false);
  const [syncedCount, setSyncedCount] = useState(0);
  // setSyncedCount is async/batched, so a closure reading `syncedCount` at
  // the end of handleSyncData would see a stale value - this ref tracks the
  // real running total synchronously for the final summary toast.
  const syncedCountRef = useRef(0);
  const failedCountRef = useRef(0);

  const bumpSyncedCount = () => {
    syncedCountRef.current += 1;
    setSyncedCount(syncedCountRef.current);
  };

  // Runs one queue (contacts/walking-list/profile/tracking/survey) sequentially,
  // waiting a beat between items to avoid bursting the backend's rate limit,
  // and bumps the visible counter after every record that actually syncs -
  // this replaced the old recursive setTimeout chains, which fired-and-forgot
  // without the caller ever knowing when (or whether) they finished.
  const syncQueue = async (items, syncOne, db, storeName) => {
    const { syncedIds, failedCount } = await runSyncQueue(items, syncOne, {
      onItemSynced: bumpSyncedCount,
    });
    failedCountRef.current += failedCount;
    await deleteItemsFromIndexedDB(db, storeName, syncedIds);
  };

  const handleSyncData = async () => {
    setIsSyncing(true);
    setSyncedCount(0);
    syncedCountRef.current = 0;
    failedCountRef.current = 0;
    try {
      const offlineSubmissions =
        JSON.parse(localStorage.getItem("offlineSubmissions")) || [];
      if (offlineSubmissions && offlineSubmissions?.length > 0) {
        const cleanedOfflineSubmission = offlineSubmissions.map((item) => {
          const { hs_context, ...formObjectWithoutHsContext } = item.formObject;
          return {
            ...item,
            formObject: formObjectWithoutHsContext,
          };
        });
        try {
          const response = await axios.post(
            `${REACT_APP_BASE_URL}/hs_form_submit`,
            { all_forms_data: cleanedOfflineSubmission },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status === 200) {
            const failedSubmissions = [];
            response.data.responses.forEach((res, index) => {
              if (res.status === "success") {
                toast.success(res.data.inlineMessage);
                bumpSyncedCount();
              } else {
                toast.error("There was an error with your survey submission.");
                failedSubmissions.push(offlineSubmissions[index]);
              }
            });
            failedCountRef.current += failedSubmissions.length;
            if (failedSubmissions.length > 0) {
              localStorage.setItem("offlineSubmissions", JSON.stringify(failedSubmissions));
            } else {
              localStorage.removeItem("offlineSubmissions");
            }
          } else {
            toast.error("Failed to submit the forms.");
          }
        } catch (error) {
          toast.error(
            error?.message ||
            "something went wrong with your survey submission."
          );
        }
      }

      const storedSyncableContacts = await fetchDataFromIndexedDB(
        syncableContactDB,
        "syncableContactsStore"
      );
      const storedSyncableWalkingList = await fetchDataFromIndexedDB(
        syncableWolkingListDB,
        "syncableWalkingListStore"
      );
      const storedSyncableProfile = await fetchDataFromIndexedDB(
        syncableProfile,
        "syncableProfileStore"
      );
      const storedSyncableTracking = await fetchDataFromIndexedDB(
        syncableTracking,
        "syncableTrackingStore"
      );
      const storedSyncableSurvey = await fetchDataFromIndexedDB(
        surveyForm,
        "surveyformStore"
      );
      const storedSyncableMeetings = await fetchDataFromIndexedDB(
        syncableMeetingDB,
        MEETING_STORE
      );

      // syncQueue removes only the records that synced, so failed or newly queued edits stay for the next sync
      if (storedSyncableContacts && storedSyncableContacts?.length > 0) {
        await syncQueue(
          storedSyncableContacts,
          (contact) => syncContactsCallApi({ id: contact?.id, ...contact?.properties }, token),
          syncableContactDB,
          "syncableContactsStore"
        );
      }
      if (storedSyncableWalkingList && storedSyncableWalkingList?.length > 0) {
        await syncQueue(
          storedSyncableWalkingList,
          (contact) => syncContactsCallApi({ id: contact?.id, ...contact?.properties }, token),
          syncableWolkingListDB,
          "syncableWalkingListStore"
        );
      }
      if (storedSyncableProfile && storedSyncableProfile?.length > 0) {
        await syncQueue(
          storedSyncableProfile,
          (contact) => syncProfileCallApi({ id: contact?.id, ...contact }, token),
          syncableProfile,
          "syncableProfileStore"
        );
      }
      if (storedSyncableTracking && storedSyncableTracking?.length > 0) {
        await syncQueue(
          storedSyncableTracking,
          (contact) => syncTrackingCallApi({ id: contact?.id, ...contact?.properties }, token),
          syncableTracking,
          "syncableTrackingStore"
        );
      }
      if (storedSyncableSurvey && storedSyncableSurvey?.length > 0) {
        await syncQueue(
          storedSyncableSurvey,
          (contact) => {
            const { id, ...data } = contact;
            return syncSurveyApi(data, token);
          },
          surveyForm,
          "surveyformStore"
        );
      }
      if (storedSyncableMeetings && storedSyncableMeetings?.length > 0) {
        await syncQueue(
          storedSyncableMeetings,
          (meeting) => syncMeetingCallApi(meeting, token),
          syncableMeetingDB,
          MEETING_STORE
        );
      }
      if (failedCountRef.current > 0) {
        toast.error(
          `${syncedCountRef.current} record(s) synced, ${failedCountRef.current} failed and will be retried on the next sync`
        );
      } else {
        toast.success(`Sync complete - ${syncedCountRef.current} record(s) updated`);
      }

      // Trigger data reload in all listening components after sync completes
      window.dispatchEvent(new CustomEvent("syncCompleted", {
        detail: {
          syncedCount: syncedCountRef.current,
          timestamp: new Date().toISOString()
        }
      }));
    } finally {
      setIsSyncing(false);
    }
  };

  const syncContactsCallApi = async (data, token) => {
    try {
      const res = await axios.put(`${REACT_APP_BASE_URL}/database`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.data) {
        console.error("Failed to send data to the server.");
      }
      return true;
    } catch (error) {
      console.log("Error occurred while sending data to the server:", error);
      return false;
    }
  };
  const syncProfileCallApi = async (data, token) => {
    try {
      const res = await axios.put(`${REACT_APP_BASE_URL}/updateprofile`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.data) {
        console.error("Failed to send data to the server.");
      }
      return true;
    } catch (error) {
      console.log("Error occurred while sending data to the server:", error);
      return false;
    }
  };
  const syncTrackingCallApi = async (data, token) => {
    try {
      const res = await axios.put(
        `${REACT_APP_BASE_URL}/householdList`,
        { ...data, owner_id: ownerID },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.data) {
        console.error("Failed to send data to the server.");
      }
      return true;
    } catch (error) {
      console.log("Error occurred while sending data to the server:", error);
      return false;
    }
  };
  const syncSurveyApi = async (data, token) => {
    try {
      const res = await axios.post(
        `${REACT_APP_BASE_URL}/post_survey_form`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data) {
        toast.success("Data successfully sent to the server");
      } else {
        console.error("Failed to send data to the server.");
      }
      return true;
    } catch (error) {
      console.log("Error occurred while sending data to the server:", error);
      return false;
    }
  };

  const handleScroll = (event) => {
    event.preventDefault();
    event.target.blur();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/user`,
        {
          email: email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const lock_code = response?.data?.lock_code;
      // A missing lock_code would otherwise match an empty or "0" PIN, since Number(null) === 0
      if (lock_code != null && lock_code !== "" && Number(lock_code) === Number(password)) {
        localStorage.setItem("lock", "false");
        setHideSidebarChecked(false);
        hideSidebar(false);
        closeModal();
        toast.success("Unlock Successfully");
      } else {
        toast.error("please correct the LockPin");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRefreshData = () => {
    if (!navigator.onLine) {
      // A reload while offline can't re-fetch the user/theme, so it would only drop the cached copies.
      toast.error("Can't refresh while offline - reconnect to the internet first");
      return;
    }
    if (isRefreshing) return;
    setIsRefreshing(true);
    refreshAppData();
  };


  const handleTimeTracking = async () => {
    const currentDate = new Date();
    const clockTime = currentDate.toISOString();
    const workDate = currentDate.toISOString().split("T")[0];
    const ownerID = localStorage.getItem("ownerId");
    let fcmToken = localStorage.getItem('fcmToken') || null;
    // Only clock-in needs a fresh FCM token (used to schedule the reminder notification).
    // Skip this entirely for clock-out so a stalled FCM/service-worker promise can never
    // block the clock-out request from firing.
    if (!isTracking) {
      try {
        const resolvedMessaging = await messagingReady;
        if (resolvedMessaging && VAPID_KEY) {
          let swReg;
          try {
            swReg = await registerPushServiceWorker();
          } catch (swErr) {
            console.warn('FCM SW registration failed at clock-in:', swErr.message);
          }
          const freshToken = await getToken(resolvedMessaging, {
            vapidKey: VAPID_KEY,
            ...(swReg ? { serviceWorkerRegistration: swReg } : {}),
          });
          if (freshToken) {
            fcmToken = freshToken;
            localStorage.setItem('fcmToken', freshToken);
          }
        }
      } catch (tokenErr) {
        console.warn('FCM token unavailable (notifications may be blocked):', tokenErr.message);
      }
    }

    try {


      if (!isTracking) {
        const response = await axios.post(
          `${REACT_APP_BASE_URL}/time_tracking_start`,
          {
            fcmToken,
            canvasser: ownerID,
            clock_in: clockTime,
            work_date_knock_knock: workDate,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setIsTracking(!!response?.data?.time_tracking);
      } else {
        const response = await axios.post(
          `${REACT_APP_BASE_URL}/time_tracking_update`,
          {
            fcmToken,
            canvasser: ownerID,
            clock_out: clockTime,
            pt_employee_notes_knock_knock: employeeNotes
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // A stale "clocked in" state can hit this endpoint when the last session was
        // already closed; the backend self-heals by starting a new session instead of
        // failing, so treat that case as clocked-in rather than clocked-out.
        setIsTracking(!!response?.data?.createdNewSession);
      }
    } catch (error) {
      console.error("Error occurred while sending time tracking data:", error);
      toast.error("Failed to update time tracking status. Please try again.");
      // Re-sync with backend truth on failure instead of trusting optimistic state
      getTimeTrackingStatus();
    }
  }
  return (
    <div className={`flex gap-5 items-center`}>
      {isMapPage && (
        <form className="flex gap-1 items-center">
          <button>
            <img
              className={`${isMapPage && "bg-canvas-white rounded-full w-8 h-8 p-2"
                }`}
              src={searchIcon}
              alt="scarchIcon"
            />
          </button>
          <div className="max-w-[220px]">
            <input
              type="text"
              placeholder="Connecticut"
              className="px-5 py-1 rounded placeholder:text-canvas-black w-full border-b border-canvas-black"
            />
          </div>
        </form>
      )}
      {isMapPage && (
        <Link>
          <img
            src={filterIcon}
            alt="filterIcon"
            className={`${isMapPage && "bg-canvas-white rounded-full w-8 h-8 p-2"
              }`}
          />
        </Link>
      )}
      <div
        className="flex gap-2 items-center cursor-pointer"
        onClick={() => setShowTrackingModal(true)}
      >
        <BsAlarm size={22} className={isTracking ? "text-canvas-success" : "text-canvas-primary"} title="Time Tracking" />
      </div>

      <div
        className="flex gap-2 items-center cursor-pointer"
        onClick={() => handleRefreshData()}
      >
        <FiRefreshCcw size={24} className={`text-canvas-primary cursor-pointer ${isRefreshing ? "animate-spin [animation-direction:reverse]" : ""}`} />
      </div>

      <div>
        {showLocationToggle && (
          <div
            className="flex gap-5 items-center cursor-pointer"
            onClick={handleLocationClick}
          >
            {locationPermission === true ? (
              <MdOutlineLocationOn size={27} className="text-canvas-primary" />
            ) : (
              <MdOutlineLocationOff size={27} className="text-canvas-primary" />
            )}
          </div>
        )}
      </div>
      <div>
        <input
          type="checkbox"
          checked={hideSidebarChecked}
          onChange={handleCheckboxChange}
          id="hs-basic-with-description-unchecked"
          className="relative w-10 h-[24px] p-px bg-white border-canvas-primary/50 text-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 disabled:opacity-50 disabled:pointer-events-none checked:bg-none checked:text-canvas-primary checked:border-canvas-primary before:inline-block before:size-5 before:bg-canvas-primary checked:before:bg-canvas-white before:border-canvas-primary before:checked:border-canvas-primary before:translate-x-0 checked:before:translate-x-4  before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 ring-0 outline-none focus:ring-0"
        />
        <div>
          <SidebarUnlockModal
            open={modalIsOpen}
            onClose={closeModal}
            setPassword={setPassword}
            isLoading={isLoading}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>

      <div className="hs-dropdown relative inline-flex">
        <button
          id="hs-dropdown-basic"
          type="button"
          className="hs-dropdown-toggle "
        >
          {online ? (
            <MdOutlineWifi className="w-5 h-5 text-canvas-success" />
          ) : (
            <MdOutlineWifiOff className="w-5 h-5 text-canvas-danger" />
          )}
        </button>

        <div
          className="hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 w-56 hidden z-10 mt-2 min-w-60 bg-white shadow-md rounded-lg "
          aria-labelledby="hs-dropdown-basic"
        >
          <button className="flex items-center justify-between gap-5 py-3 px-3  w-full border-b">
            <h4>Status {online ? "Online" : "Offline"}</h4>
            {online ? (
              <MdOutlineWifi className="w-5 h-5 text-canvas-secondery" />
            ) : (
              <MdOutlineWifiOff className="w-5 h-5 text-canvas-secondery" />
            )}
          </button>
          {online && (
            <button
              className="flex items-center justify-between gap-5 py-3 px-3 w-full border-b disabled:opacity-60 disabled:cursor-progress"
              onClick={handleSyncData}
              disabled={isSyncing}
            >
              <h6>{isSyncing ? "Syncing..." : "Synchronize Now"}</h6>
              <div className="flex items-center gap-2">
                {isSyncing && (
                  <span className="text-xs font-semibold text-canvas-secondery">{syncedCount} synced</span>
                )}
                <LuArrowDownUp
                  className={`w-5 h-5 text-canvas-secondery ${isSyncing ? "animate-spin" : ""}`}
                />
              </div>
            </button>
          )}
        </div>
      </div>
      {isAdmin && !isGhostMode && !hideSidebarChecked && (
        <GhostUserSelector
          userList={userList}
          isLoadingUsers={isLoadingUsers}
          onSelectUser={initiateGhostMode}
          onRefresh={refreshUserList}
          currentUser={null}
        />
      )}
      {!hideSidebarChecked && !isGhostMode && <TenantSwitcherMenu />}
      {!hideSidebarChecked && <UserMenu />}
      <ConfirmModal
        open={showTrackingModal}
        onClose={() => setShowTrackingModal(false)}
        confirmLabel="Yes"
        cancelLabel="No"
        onConfirm={() => {
          handleTimeTracking();
          setShowTrackingModal(false);
        }}
        children={

          <>
            {
              isTracking ?
                <EditInputField label={'Employee Notes'} value={employeeNotes} onChange={(e) => setEmployeeNotes(e.target.value)} /> : ""
            }</>}
        title={isTracking ? 'Do you want to Clock out ?' : 'Do you want to clock in ?'}
      />
      <GhostModeWarningModal
        isOpen={showWarningModal}
        onConfirm={() => confirmGhostMode()}
        onCancel={cancelGhostMode}
        targetUser={pendingGhostUser}
      />
      {ghostTenantChoices && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-xl w-80 p-4">
            <h3 className="text-sm font-semibold text-gray-700 mb-1">
              Select a tenant
            </h3>
            <p className="text-xs text-gray-500 mb-3">
              {pendingGhostUser?.email} isn't in your current tenant. Choose which of their tenants to view as them.
            </p>
            {ghostTenantChoices.length === 0 ? (
              <p className="text-sm text-gray-500 mb-3">
                This user has no active tenant membership.
              </p>
            ) : (
              <ul className="max-h-64 overflow-y-auto divide-y divide-gray-100 mb-3">
                {ghostTenantChoices.map((tenant) => (
                  <li key={tenant.id}>
                    <button
                      type="button"
                      onClick={() => selectGhostTenant(tenant)}
                      className="w-full text-left px-2 py-2 text-sm hover:bg-gray-50 rounded"
                    >
                      {tenant.name}
                    </button>
                  </li>
                ))}
              </ul>
            )}
            <button
              type="button"
              onClick={cancelGhostTenantSelection}
              className="w-full py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded hover:bg-gray-50"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Usersbar;
